import { render, staticRenderFns } from "./FaceReader.vue?vue&type=template&id=67c017e6"
import script from "./FaceReader.vue?vue&type=script&lang=ts"
export * from "./FaceReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports